/** 表单设计器类型：主视图（Main View） */
export const DESFORM_TYPE_MV = 1
/** 表单设计器类型：子视图（Sub View） */
export const DESFORM_TYPE_SV = 2
